import React, { useState, useEffect } from 'react';
import Box from '@mui/material/Box';

import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';

import MenuItem from '@mui/material/MenuItem';

import BusinessIcon from '@mui/icons-material/Business';

import { Select, FormControl, InputLabel, OutlinedInput, TextField, InputAdornment } from '@mui/material';

import Container from '@mui/material/Container';

import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import BusinessCenterIcon from '@mui/icons-material/BusinessCenter';
import LocalHospitalIcon from '@mui/icons-material/LocalHospital';
import PublicIcon from '@mui/icons-material/Public';
import PeopleIcon from '@mui/icons-material/People';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import SchoolIcon from '@mui/icons-material/School';
import CorporateFareIcon from '@mui/icons-material/CorporateFare';
import Link from '@mui/material/Link';

import SearchIcon from '@mui/icons-material/Search';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { useAuth } from '../../context/AuthContext';
import Footer from '../Materials/Footer';
import BurgerBar from '../Materials/BurgerBar';
import Map from '../Mapa/mapa';

export default function EntitiesPage() {
  const [anchorEl, setAnchorEl] = useState(null);
  const [openDrawer, setOpenDrawer] = useState(false);
  const [expandedEntity, setExpandedEntity] = useState(null);
  const [selectedEntity, setSelectedEntity] = useState('');
  const [entities, setEntities] = useState([]);
  const [filteredEntities, setFilteredEntities] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [searchResults, setSearchResults] = useState({ entities: [], equipments: [] });
  const navigate = useNavigate();
  const { isRestrictedUser } = useAuth();

  // Mapeamento dos tipos de entidade para seus respectivos IDs
  const entityTypeMap = {
    "CTI": "94203ded-0008-4f2f-a2cc-3ced8d5f3af4",
    "Pilot Plant": "7f0798b5-5622-4f2c-b694-44a82b2a5e1b",
    "Public Organization": "5b0a6c8e-67b5-4fd9-b5d7-55c3a95b5f8a",
    "Cluster": "307778b5-d433-48c8-9f51-d5de79e2adb6",
    "SME": "bf03524c-5f10-4ddf-ad82-daaf476fd34f",
    "Large Company": "7427ce1b-0428-4d07-a7de-302e35f60f97",
    "Nonprofit Association": "61d11fc2-1e84-4921-8b0b-c75c06504635",
    "University": "5734a36b-9aee-4939-8872-fd5ed340834b"
  };

  // Fetch entities
  const fetchEntities = async () => {
    try {
      const response = await fetch('https://api.hub4food.colab4food.com/api/entities');
      if (!response.ok) {
        throw new Error('Erro ao buscar as entidades');
      }
      const data = await response.json();

      // Filtrando apenas as entidades visíveis
      const visibleEntities = data.filter(entity => entity.is_visible);

      // Ordenando as entidades por nome em ordem alfabética
      const sortedData = visibleEntities.sort((a, b) => a.name.localeCompare(b.name));

      setEntities(sortedData);
      setFilteredEntities(sortedData);
    } catch (error) {
      console.error('Erro ao buscar entidades:', error);
    }
  };

  // Fetch entities and equipments for search
const fetchEntitiesAndEquipments = async (term) => {
  try {
    const responseEntities = await fetch('https://api.hub4food.colab4food.com/api/entities');
    const dataEntities = await responseEntities.json();
    const filteredEntities = dataEntities.filter(entity =>
      entity.name.toLowerCase().includes(term.toLowerCase())
    );

    const responseEquipments = await fetch('https://api.hub4food.colab4food.com/api/equipments');
    const dataEquipments = await responseEquipments.json();
    
    // Enriquecer os equipamentos com o nome da entidade
    const enrichedEquipments = dataEquipments.map(equipment => {
      const entity = dataEntities.find(entity => entity.id === equipment.entity_id);
      return {
        ...equipment,
        entity_name: entity ? entity.name : 'Unknown Entity'
      };
    });

    const filteredEquipments = enrichedEquipments.filter(equipment =>
      equipment.equipment_name.toLowerCase().includes(term.toLowerCase())
    );

    setSearchResults({ entities: filteredEntities, equipments: filteredEquipments });
  } catch (error) {
    console.error('Erro ao buscar entidades e equipamentos:', error);
  }
};

  useEffect(() => {
    fetchEntities();
  }, []);

  const handleMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleDrawerToggle = () => {
    setOpenDrawer(!openDrawer);
  };

  const handleToggleExpand = (index) => {
    if (expandedEntity === index) {
      setExpandedEntity(null);
    } else {
      setExpandedEntity(index);
    }
  };

  const handleEntityChange = (event) => {
    const selectedType = event.target.value;
    setSelectedEntity(selectedType);

    let filtered = [];
    if (selectedType === "") {
      filtered = entities; 
    } else {
      const typeId = entityTypeMap[selectedType];
      filtered = entities.filter(entity => entity.entity_type_id === typeId);
    }

    const sortedFilteredEntities = filtered.sort((a, b) => a.name.localeCompare(b.name));
    setFilteredEntities(sortedFilteredEntities);
  };

  const handleNavigation = (path) => {
    navigate(path);
    setOpenDrawer(false);
  };

  const handleEntityClick = (entity) => {
    navigate(`/detailedentities/${entity.id}`);
  };

  const handleExit = () => {
    navigate('/');
  };

  return (
    <Box sx={{ flexGrow: 1 }}>
      {/* Navbar */}
      <BurgerBar />

      {/* Search Section */}
      <Container
        maxWidth="md"
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          textAlign: 'center',
          py: 4,
        }}
      >
        <motion.header
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
          {!isRestrictedUser && (
            <Typography variant="h4" component="h1" gutterBottom sx={{ fontWeight: 'bold', mb: 3 }}>
              Explore the Entities of Hub4Food<sup>®</sup>
            </Typography>
          )}

          {/* Search bar */}
          {!isRestrictedUser && (
            <>
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.8, delay: 0.2 }}
                style={{ position: 'relative', width: '100%' }}
              >
                <TextField
                  variant="outlined"
                  placeholder="Search entities and equipment..."
                  className="search-bar"
                  value={searchTerm}
                  onChange={(e) => {
                    setSearchTerm(e.target.value);
                    fetchEntitiesAndEquipments(e.target.value);
                  }}
                  onKeyPress={(e) => {
                    if (e.key === 'Enter' && searchTerm.trim()) {
                      navigate(`/searchresults?query=${encodeURIComponent(searchTerm.trim())}`);
                      setSearchResults({ entities: [], equipments: [] });
                      setSearchTerm('');
                    }
                  }}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <IconButton
                          onClick={() => {
                            if (searchTerm.trim()) {
                              navigate(`/searchresults?query=${encodeURIComponent(searchTerm.trim())}`);
                              setSearchResults({ entities: [], equipments: [] });
                              setSearchTerm('');
                            }
                          }}
                          edge="start"
                        >
                          <SearchIcon style={{ color: '#757575' }} />
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                  sx={{ width: '100%', mb: 2 }}
                />

                {searchTerm && (searchResults.entities.length > 0 || searchResults.equipments.length > 0) && (
                  <motion.div
                    className="search-results"
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{ duration: 0.3 }}
                    style={{
                      position: 'absolute',
                      top: '100%',
                      left: 0,
                      right: 0,
                      backgroundColor: 'white',
                      border: '1px solid #ddd',
                      borderRadius: '4px',
                      boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                      zIndex: 1000,
                      maxHeight: '300px',
                      overflowY: 'auto'
                    }}
                  >
                    {searchResults.entities.length > 0 && (
                      <Box>
                        <Typography className="search-section" sx={{ p: 1, fontWeight: 'bold', borderBottom: '1px solid #eee' }}>
                          Entities
                        </Typography>
                        {searchResults.entities.map((entity) => (
                          <MenuItem
                            key={entity.id}
                            onClick={() => {
                              navigate(`/detailedentities/${entity.id}`);
                              setSearchResults({ entities: [], equipments: [] });
                              setSearchTerm('');
                            }}
                            className="search-item"
                          >
                            {entity.name}
                          </MenuItem>
                        ))}
                      </Box>
                    )}

                    {searchResults.equipments.length > 0 && (
  <Box>
    <Typography className="search-section" sx={{ p: 1, fontWeight: 'bold', borderBottom: '1px solid #eee' }}>
      Equipments
    </Typography>
    {searchResults.equipments.map((equipment) => (
      <MenuItem
        key={equipment.id}
        onClick={() => {
          navigate(`/detailedEquipment/${equipment.id}`);
          setSearchResults({ entities: [], equipments: [] });
          setSearchTerm('');
        }}
        className="search-item"
        sx={{ 
          display: 'flex', 
          flexDirection: 'column', 
          alignItems: 'flex-start',
          py: 1.5
        }}
      >
        <Typography variant="body1" sx={{ fontWeight: 'medium' }}>
          {equipment.equipment_name}
        </Typography>
        <Typography 
          variant="body2" 
          sx={{ 
            color: 'text.secondary', 
            fontSize: '0.8rem',
            mt: 0.5
          }}
        >
        {equipment.entity_name}
        </Typography>
      </MenuItem>
    ))}
  </Box>
)}
                  </motion.div>
                )}
              </motion.div>

              <motion.div
                className="oriented-search-container"
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ duration: 0.8, delay: 0.3 }}
                style={{ textAlign: 'center', marginTop: '10px' }}
              >
                <Link href="/orientedsearch" className="oriented-search" sx={{ fontSize: '1rem', textDecoration: 'none' }}>
                  Oriented Search
                </Link>
              </motion.div>
            </>
          )}
        </motion.header>
      </Container>

      {/* Entities Content */}
      <Box sx={{ p: 3, maxWidth: '90%', margin: '0 auto' }}>
        {/* Centralized Entities Section */}
        <Box sx={{ textAlign: 'center', mb: 0 }}>
  
          <FormControl sx={{ minWidth: 200, marginBottom: 2 }} variant="outlined">
            <InputLabel htmlFor="entity-select">Select Your Entity</InputLabel>
            <Select
              value={selectedEntity}
              onChange={handleEntityChange}
              label="Select Your Entity"
              input={<OutlinedInput label="Select Your Entity" />}
            >
              <MenuItem value="">All Entities</MenuItem>
              <MenuItem value="CTI">
                <BusinessCenterIcon sx={{ marginRight: 2 }} />
                CTI
              </MenuItem>
              <MenuItem value="Pilot Plant">
                <LocalHospitalIcon sx={{ marginRight: 2 }} />
                Pilot Plant
              </MenuItem>
              <MenuItem value="Public Organization">
                <PublicIcon sx={{ marginRight: 2 }} />
                Public Organization
              </MenuItem>
              <MenuItem value="Cluster">
                <PeopleIcon sx={{ marginRight: 2 }} />
                Cluster
              </MenuItem>
              <MenuItem value="SME">
                <BusinessIcon sx={{ marginRight: 2 }} />
                SME
              </MenuItem>
              <MenuItem value="Large Company">
                <CorporateFareIcon sx={{ marginRight: 2 }} />
                Large Company
              </MenuItem>
              <MenuItem value="Nonprofit Association">
                <AccountBalanceIcon sx={{ marginRight: 2 }} />
                Nonprofit Association
              </MenuItem>
              <MenuItem value="University">
                <SchoolIcon sx={{ marginRight: 2 }} />
                University
              </MenuItem>
            </Select>
          </FormControl>
        </Box>

        {/* Entity List Section */}
        <Box>
          {filteredEntities.map((entity, index) => (
            <Box
              key={index}
              sx={{
                display: 'flex',
                flexDirection: 'column',
                marginBottom: '16px',
                padding: '16px',
                cursor: 'pointer',
              }}
              onClick={() => handleEntityClick(entity)}
            >
              <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <img
                  src={
                    entity.image_path
                      ? `https://api.hub4food.colab4food.com/${entity.image_path}`
                      : 'logocolab.png'
                  }
                  alt={entity.name}
                  style={{
                    width: '25px',
                    height: 'auto',
                    marginRight: '16px',
                    borderRadius: '8px',
                  }}
                />
                <Typography variant="h6" sx={{ fontSize: '1rem', flex: 1, color: 'blue' }}>
                  {entity.name}
                </Typography>
                <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                  <IconButton
                    onClick={(e) => {
                      e.stopPropagation();
                      handleToggleExpand(index);
                    }}
                    sx={{ alignSelf: 'center' }}
                  >
                    <ExpandMoreIcon />
                  </IconButton>
                </Box>
              </Box>
              
              {expandedEntity === index && (
                <Box sx={{ textAlign: 'center', marginTop: 2 }}>
                  <Typography variant="body2" color="textSecondary" sx={{ mb: 1 }}>
                    {entity.description} 
                  </Typography>
                  <Typography variant="caption" color="textSecondary">
                    <Link 
                      href={entity.website} 
                      target="_blank" 
                      rel="noopener noreferrer"
                    >
                      {entity.website}
                    </Link>
                  </Typography>
                </Box>
              )}
            </Box>
          ))}
        </Box>

  {/* Mapa*/}
{!isRestrictedUser && (
  <motion.section
    initial={{ opacity: 0 }}
    whileInView={{ opacity: 1 }}
    viewport={{ once: true }}
    transition={{ duration: 0.8 }}
    style={{ 
      marginTop: '60px',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      width: '100%'
    }}
  >
    {/* Título do Mapa */}
    <Typography 
      variant="h5" 
      component="h2" 
      sx={{ 
        fontWeight: 'bold', 
        mb: 3,
        textAlign: 'center',
        width: '100%'
      }}
    >
      Mapa das Entidades
    </Typography>
    
    <Box 
      sx={{ 
        width: '100%', 
        maxWidth: '1200px',
        display: 'flex',
        justifyContent: 'center'
      }}
    >
      <Map />
    </Box>
  </motion.section>
)}
      </Box>

      <Box>
        <Footer />
      </Box>
    </Box>
  );
}